// src/components/AuthHandler.tsx

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import { UserRole } from '../types/UserRole';


export const AuthHandler = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // currentUserに値がセットされ（＝ログイン成功）、かつ現在ログインページにいる場合にリダイレクトを実行
    if (currentUser && location.pathname === '/login') {
      toast.success('ログインしました');
      if (currentUser.role !== UserRole.Farmer) {
        navigate('/admin');
      } else {
        navigate('/');
      }
    }
  }, [currentUser, navigate, location]); // currentUser, navigate, locationが変更されたらこの処理を実行

  // このコンポーネント自体は何も画面に表示しないのでnullを返す
  return null; 
};